import { Controller } from "@hotwired/stimulus";
import { PostHog, Properties } from "@posthog/types";

declare global {
  interface Window {
    posthog?: PostHog;
  }
}

export default class extends Controller<HTMLElement> {
  static values = {
    event: String,
    properties: Object,
  };

  declare eventValue: string;
  declare propertiesValue: Properties | undefined;

  track(): void {
    // we only initialise posthog for eligible users, and under
    // a feature flag - if it's not initialised, don't try
    // to track anything.
    if (!window.posthog) {
      return;
    }

    const properties: Properties = this.propertiesValue || {};
    window.posthog.capture(this.eventValue, properties);
  }
}
